import type { FC } from 'react';
import clsx from 'clsx';
import type { LinksFunction } from '@remix-run/node';

import { SharedIcon } from '../shared-icon/shared-icon';
import { SharedAnchor } from '../shared-anchor/shared-anchor';
import type {
  SharedStoreButtonItemType,
  SharedStoreButtonProps,
  SharedStoreButtonType,
} from './shared-store-button.types';

import styles from './shared-store-button.css?url';

export const links: LinksFunction = () => [{ rel: 'stylesheet', href: styles }];

const storeMap: Record<SharedStoreButtonType, SharedStoreButtonItemType> = {
  ios: {
    href: 'https://apps.apple.com/us/app/aura-protect-your-identity/id1547735089',
    icon: 'ios',
    title: 'App Store',
    pretitle: 'Download on the',
  },
  'google-play': {
    href: 'https://play.google.com/store/apps/details?id=com.aura.suite',
    icon: 'google-play',
    title: 'Google Play',
    pretitle: 'Get it on',
  },
};

export const SharedStoreButton: FC<SharedStoreButtonProps> = ({
  className = '',
  type,
  theme,
}) => {
  const store = storeMap[type];

  if (!store) {
    return null;
  }

  const classes = clsx(
    'shared-store-button',
    `shared-store-button--theme-${theme}`,
    className,
  );

  return (
    <SharedAnchor href={store.href} className={classes} isNewTab>
      <SharedIcon name={store.icon} />
      <div className="shared-store-button__inner">
        <div className="shared-store-button__pretitle">{store.pretitle}</div>
        <div className="shared-store-button__title">{store.title}</div>
      </div>
    </SharedAnchor>
  );
};
